import { useEffect, useState } from "react";
import ProgressBar from "../../../common/ProgressBar";
import { delay } from "../../../utils";
import Badge from "./Badge";
import useCompany from "../../../hooks/useCompany";
import useSVG from "../../../hooks/useSVG";

function Milestone(props) {
    let { type, value, max, min, stage, challenge, upcoming = null, user, useChaTitle = false } = props;
    const { companyLogo, companyName } = useCompany({ user: user })
    const { UseChalengesSVG } = useSVG();
    const [val, setVal] = useState(0);

    value = Math.round(value)

    useEffect(() => {
        delay(() => {
            setVal(1);
        }, 400)
    }, [])


    let caption = "";
    let isComplete = false;
    let isDone = value >= max;

    if (min > value) {
        caption = "Milestone #" + stage;
    } else if (isDone) {
        caption = "Complete! Great work!";
        isComplete = true;
    } else {
        caption = `${max - value} ${type} to your next milestone`
    }

    const baseurl = process.env.REACT_APP_ENVIRONMENT == "PROD" ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV;
    let milestoneHeader = !upcoming ? `${max} ${type?.toUpperCase()}` : upcoming.header;
    milestoneHeader = useChaTitle ? challenge?.title : milestoneHeader;

    const gradient = challenge?.gradient?.split("-");
    const fontStyle = value > min ? { color: `${gradient?.[0]}` } : {};
    const circleStyle = (challenge?.gradient && value > min) ? { backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})` } : { backgroundColor: "#a1a1a1" };


    const challengeBadge = (process.env.REACT_APP_ENVIRONMENT == "PROD" ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV) + challenge?.badge;
    return (
        <div className={"cc-milestone " + (isDone ? "done" : "") + (upcoming ? "upcoming" : "")} >
            <div className="cc-milestone-circle" style={circleStyle}>

                {
                    (challenge?.company)
                        ? <Badge isComplete={isComplete} challenge={challenge} logo={(challenge?.company) ? challengeBadge : null} />
                        : challenge?.svg ? UseChalengesSVG(challenge?.svg) : ""
                }
            </div>
            <div className="cc-milestone-desc">
                <h5 style={fontStyle}>
                    {(challenge?.company) ? (challenge?.title?.toUpperCase()) : milestoneHeader}
                </h5>
                <p style={fontStyle}>
                    {
                        !upcoming ? caption : upcoming.subtext
                    }
                </p>
                {
                    !upcoming && <ProgressBar min={min} max={max} value={val ? value : 0} height="7px" showLabel={false} barColor="#fff" gradient={gradient} />
                }
            </div>
        </div>
    );
}

export default Milestone;